import React from "react";

import { View, StyleSheet } from "react-native";
import { useTheme } from "react-native-paper";
import { ThemeType, SpacingValues } from "../../theme/theme";

interface IContainer {
  theme: ThemeType;
  space?: SpacingValues;
  horizontalSpace?: SpacingValues;
  cropEndSpace: boolean;
  children: any;
}
const getChildrenStyle = (
  { theme, space = "medium", horizontalSpace = "none", cropEndSpace = true, children }: IContainer,
  index: number
) => {
  const childStyle: any[] = [
    {
      marginBottom: theme.spacing[space],
    },
  ];
  if (index === 0) {
    childStyle.push({
      marginTop: theme.spacing[space],
    });
  }
  if (horizontalSpace) {
    childStyle.push({
      marginHorizontal: theme.spacing[horizontalSpace],
    });
  }
  if (cropEndSpace) {
    if (index === 0) {
      childStyle.push({
        marginTop: 0,
      });
    }
    if (index === React.Children.count(children) - 1) {
      childStyle.push({
        marginBottom: 0,
      });
    }
  }
  return childStyle;
};

export const Stack = (props: IStack) => {
  const theme = useTheme() as ThemeType;
  return (
    <View
      style={StyleSheet.compose(
        props.style,
        props.useThemeBackgroundColor ? { backgroundColor: theme.colors.background } : null
      )}>
      {React.Children.toArray(props.children).map((item, index) => {
        return (
          <View style={getChildrenStyle({ ...props, theme }, index)} key={index} accessible={true}>
            {item}
          </View>
        );
      })}
    </View>
  );
};
interface IStack {
  style?: Record<string, any>;
  space?: SpacingValues;
  useThemeBackgroundColor?: boolean;
  horizontalSpace?: SpacingValues;
  children: any;
  cropEndSpace: boolean;
}

Stack.defaultProps = {
  space: "medium",
  horizontalSpace: "none",
  useThemeBackgroundColor: true,
  cropEndSpace: true,
};
